import AOS from "aos";
import contacto from "./contacto";

document.addEventListener("DOMContentLoaded", function () {
	/*
	-------------------------------
	Animacion scroll
	-------------------------------
	*/
	AOS.init();

	var scrollRef = 0;
	window.addEventListener("scroll", function () {
		// increase value up to 10, then refresh AOS
		if (scrollRef <= 10) {
			scrollRef++;
		} else {
			AOS.refresh();
		}
	});
});

/*
-------------------------------
Contacto
-------------------------------
*/
contacto();
